export class RiferimentoFascicoloCartaceoDTO {
    collocazioneFisica: string;
    descrizioneContenuto: string;
}